import { render, staticRenderFns } from "./MyBuildings.vue?vue&type=template&id=2274808b&"
import script from "./MyBuildings.vue?vue&type=script&lang=js&"
export * from "./MyBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports